import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'curbnturf-category-svg',
  templateUrl: './category-svg.component.html',
  styleUrls: ['./category-svg.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass],
})
export class CategorySvgComponent {
  @Input() icon: string;
  @Input() white: boolean = false;
}
